export const useInternalLinkHandler = () => {
  const router = useRouter()
  const { locale } = useI18n()
  const localePath = useLocalePath()

  const internalLinksListener = (element) => {
    element.addEventListener('click', async (e) => {
      const href = element.getAttribute('href')
      if (!href) return

      if (element.getAttribute('target') === '_blank') {
        return
      }

      const url = new URL(href, window.location.origin)

      const isFile =
        /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar|jpe?g|png|gif|svg)$/i.test(
          url.pathname
        )

      if (isFile) return

      const currentHost = window.location.host
      const linkHost = url.host

      if (linkHost !== currentHost) {
        return
      }
      e.preventDefault()
      e.stopPropagation()

      const path = url.pathname
      const slugArr = path.split('/').filter(Boolean)

      const translations = {
        cs: {
          stranka: 'article',
          oddeleni: 'department',
          zamestnanec: 'employee',
          aktualita: 'notice',
          publikace: 'publication',
          ostatni: 'other',
        },
        en: {
          article: 'article',
          department: 'department',
          employee: 'employee',
          notice: 'notice',
          publication: 'publication',
          other: 'other',
        },
      }

      let routeConfig = null

      if (locale.value === 'cs' && slugArr[0] && translations.cs[slugArr[0]]) {
        const type = slugArr[0]
        const slug = slugArr[1]

        routeConfig =
          type === 'ostatni'
            ? {
                name: `other-${slug === 'publikace' ? 'publication' : 'people'}`,
              }
            : {
                name: `${translations.cs[type]}-slug`,
                params: { slug: slug },
              }
      } else if (
        locale.value === 'en' &&
        slugArr[0] === 'en' &&
        slugArr[1] &&
        translations.en[slugArr[1]]
      ) {
        const type = slugArr[1]
        const slug = slugArr[2]

        routeConfig =
          type === 'other'
            ? { name: `${translations.en[type]}-${slug}` }
            : {
                name: `${translations.en[type]}-slug`,
                params: { slug: slug },
              }
      }

      if (routeConfig) {
        return navigateTo(localePath(routeConfig))
      } else {
        await router.push(path)
      }
    })
  }

  return { internalLinksListener }
}
